
const ServicesHero = () => {
  return (
    <section 
      className="relative pt-24 sm:pt-28 md:pt-32 pb-12 sm:pb-16 md:pb-20 overflow-hidden bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(59, 130, 246, 0.7), rgba(96, 165, 250, 0.7)), url('https://static.readdy.ai/image/f4befc687b50546f577c3e945d9e0997/8545ddd3ab015b11e0be9dd6cd892762.jpeg')`
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6">
          Nos Services
        </h1>
        <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-blue-50 max-w-3xl mx-auto leading-relaxed px-4">
          Une expertise complète dans tous les domaines de la construction, 
          de la rénovation et de l'aménagement pour vos projets résidentiels, 
          commerciaux et industriels.
        </p>
      </div>
    </section>
  );
};

export default ServicesHero;
